/**
 * 项目全局配置
 */
/** 测试环境 */
const isDev = window.location.href.indexOf("_env=DEV") !== -1;

/** 页面默认参数 */
const config = {
  /**页面域名 */
  baseURL: isDev
    ? "//testmerpla.api.mgtv.com" // 测试环境
    : "//mgcclub.api.mgtv.com", // 正式环境
  userInfoURL: "//nuc.api.mgtv.com",
  /**页面域名 */
  actUrl: isDev
    ? "https://testmerpla.api.mgtv.com" // 测试环境
    : "https://mgcact.api.mgtv.com", // 正式环境
  /** 社区域名 */
  clubUrl: "https://mgccmt.api.mgtv.com", // 测试环境 175.6.15.155
  clubHomeUrl: isDev
    ? "https://h5.mgtv.com/2023/3488d64f/index.html"
    : "https://h5.mgtv.com/2023/mgcard-club-h5/index.html",
};
/**
 * 获取项目全局配置
 * @returns Object
 */
const getConfig = () => config;

export default getConfig;
